<template>
    <button class="btn btn--big btn--tertiary" @click="ConfirmAndRevoke()">{{ trans('users.label.revoke_agreements') }}</button>
</template>

<script>
    import { EventBus } from '../eventbus.js';

    export default {
        props: ['confirmTitle', 'confirmText'],
        methods: {
            ConfirmAndRevoke() {
               this.$alertify.confirmWithTitle(
                    this.trans('users.note.revoke_agreements'),
                    this.trans('users.note.revoke_agreements_message'),
                    () => {
                        axios
                            .get(this.route('tenant.agreements.revoke'))
                            .then(response => {
                                window.location.replace(this.route('dashboard'));
                            })
                            .catch((error) => {
                                this.flash({
                                    message: error.response.data.error_message,
                                    level: 'warning'
                                });
                            });
                    }
                );
            }
        }
    }
</script>
